import {ADMIN_VERSION_API} from "@/contants/api";
const contactRoute = `${ADMIN_VERSION_API}/contacts`;

export default $axios => ({
  index(page) {
    return $axios.get(`${contactRoute}?page=${page}`);
  }
});